module.exports = __webpack_public_path__ + "static/Lei1-2b0bb8a023c349dc34d54243b45944ad.jpg";